class TrusteeDashboardService {
	constructor($http, $window, $timeout, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}


	init() {

    }
}


export default /* @ngInject */ ($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) =>
	new TrusteeDashboardService($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService);